/**
 * Résultat de l'analyse OCR
 */
export interface OcrResult {
  extractedText: string;
  confidence: number;
  detectedKeywords: string[];
}

/**
 * Résultat de la vérification du certificat
 */
export interface CertificateVerificationResult {
  isValid: boolean;
  confidenceScore: number;
  ocrResult: OcrResult;
  rejectionReason?: string;
  details?: {
    requiredKeywordsFound: number;
    requiredKeywordsTotal: number;
    optionalKeywordsFound: number;
    yearDetected: string | null;
    textLength: number;
  };
}

/**
 * Réponse après upload et vérification d'un certificat
 */
export interface UploadCertificateResponse {
  message: string;
  id: number; // ID du certificat en base (utilisé lors de l'inscription)
  verification: CertificateVerificationResult;
  filePath: string; // URL publique du certificat
}

/**
 * Statuts de compte possibles
 */
export enum AccountStatus {
  ATTENTE = 1,      // En attente de validation
  VALIDE = 2,       // Compte validé
  RENOUVELLEMENT = 3, // Renouvellement requis (1er octobre)
  DESACTIVE = 10    // Compte désactivé
}

/**
 * Labels des statuts
 */
export const AccountStatusLabels: Record<AccountStatus, string> = {
  [AccountStatus.ATTENTE]: 'En attente',
  [AccountStatus.VALIDE]: 'Validé',
  [AccountStatus.RENOUVELLEMENT]: 'Renouvellement requis',
  [AccountStatus.DESACTIVE]: 'Désactivé'
};
